import React from 'react';

import isEmpty from 'lodash/isEmpty';
import sum from 'lodash/sum';

import { IconButton, ConfirmDialog, CloseIcon } from '@gogame/components';
import { useScreenModalV2 } from '@gogame/screens';

import { useGroup } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Group';
import { useLoader } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Loader';
import { useViewStateByPath } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';
import { useRemoveNodeMarketingPlan } from 'scenes/MarketingPlanning/MarketingPlanningWizard/hooks';

const getNumberOfNodesDepth = ({ nodes }) => {
  const cNodes = nodes.map(getNumberOfNodesDepth);
  return sum(cNodes) + 1;
};

const RemoveNode = ({ levelName = 'node ' }) => {
  const { processAsync } = useLoader();
  const { levelPath } = useGroup();
  const removeNode = useRemoveNodeMarketingPlan(processAsync);

  const showConfirmDialog = useScreenModalV2(ConfirmDialog);

  const { id, name, nodes } = useViewStateByPath(levelPath);

  const handleRemoveNode = React.useCallback(async () => {
    if (!isEmpty(nodes)) {
      const numberOfNodes = getNumberOfNodesDepth({ nodes });
      await showConfirmDialog({
        title: `Remove ${
          levelName === 'Countries' ? 'Country' : levelName.slice(0, -1)
        }`,
        bodyText: `Removing "${name}" will also remove all of its child entities (${numberOfNodes}).`,
        confirmActionLabel: 'Remove',
      });
      await removeNode({ id, levelPath });
    } else {
      await removeNode({ id, levelPath });
    }
  }, [
    getNumberOfNodesDepth,
    showConfirmDialog,
    removeNode,
    id,
    levelPath,
    nodes,
  ]);

  return (
    <IconButton
      tooltip={'Remove'}
      icon={<CloseIcon />}
      onClick={handleRemoveNode}
    />
  );
};

export default RemoveNode;
